import React, { useEffect, useRef } from "react";

/**
 * Carte Leaflet avec marqueur draggable.
 * Props : latitude, longitude (valeurs initiales), onChange({latitude, longitude})
 */
export default function MapPicker({ latitude, longitude, onChange }) {
  const mapRef = useRef(null);
  const leafletMap = useRef(null);
  const marker = useRef(null);
  const onChangeRef = useRef(onChange);
  useEffect(() => { onChangeRef.current = onChange; }, [onChange]);

  useEffect(() => {
    const L = window.L;
    if (!L || !mapRef.current || leafletMap.current) return;

    leafletMap.current = L.map(mapRef.current).setView([latitude, longitude], 17);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "© OpenStreetMap", maxZoom: 19,
    }).addTo(leafletMap.current);

    marker.current = L.marker([latitude, longitude], {
      draggable: true, autoPan: true,
    }).addTo(leafletMap.current);

    marker.current.on("dragend", () => {
      const ll = marker.current.getLatLng();
      onChangeRef.current && onChangeRef.current({ latitude: ll.lat, longitude: ll.lng });
    });
    leafletMap.current.on("click", (e) => {
      marker.current.setLatLng(e.latlng);
      onChangeRef.current && onChangeRef.current({ latitude: e.latlng.lat, longitude: e.latlng.lng });
    });

    setTimeout(() => leafletMap.current && leafletMap.current.invalidateSize(), 100);
    return () => {
      if (leafletMap.current) { leafletMap.current.remove(); leafletMap.current = null; }
    };
    // eslint-disable-next-line
  }, []);

  // Sync externe (édition manuelle des coords)
  useEffect(() => {
    if (marker.current && latitude && longitude) {
      const ll = marker.current.getLatLng();
      if (Math.abs(ll.lat - latitude) > 1e-7 || Math.abs(ll.lng - longitude) > 1e-7) {
        marker.current.setLatLng([latitude, longitude]);
      }
    }
  }, [latitude, longitude]);

  return <div ref={mapRef} className="carto-editor-map" />;
}
